import axios from "axios";
import { getDest } from "./routeUtils/destination";
import { getAcrossService, fetchDocketDetails } from "../services/operations";
import { fedexCreatePickup } from "../services/fedex";
import { getCityByPincode } from "../services/area";
import { unloadPackages } from "../services/unloading";
import {
  SHOW_LOADER,
  HIDE_LOADER,
  SET_DOCKET,
  SET_ACROSS,
  RESET_EDIT,
} from "../constants/booking";

import { DELIVERY_PENDING, DELIVERY_SUCCESS } from "../constants/delivery";

import {
  SET_RECEIVED_UNAPPROVED_MEMOS,
  APPROVE_OR_REJECT_NOTIFY_MEMO,
} from "../constants/memo";

import { baseURL } from "../axios";

import {
  fetchIncentiveAmount,
  fetchRouteForExpense,
} from "../services/expenses";

import { getUnapprovedMemosService } from "../services/memo";

import { userAllBalancesService } from "../services/user";

import { failed, showHttpError, showMessage } from "../utils/message";

// import showErrorMessage from "../containers/generics/showErrorMessage";
import { pendingApproval } from "../services/franchise";
import jsonToFormdata from "../utils/jsonToFormdata";
import {
  returnODAPackagesService
} from "../services/delivery";
import { fetchBranchwiseBookingCounters } from "../services/booking";
// import getOperationRequestCount from "../services/operationsCount";
import { Dispatch } from "redux";
import { getOutForDeliveryData } from "../services/fleet";
import { countsCCAvenueTxns } from "../services/paymentGateWay";
import { getMaterialList } from "../services/intraCityRate";
import { RootState } from "../redux/store";
import { GET_ROUTES } from "../constants/route";
import { changeSimple } from "../redux/slices/branch/branchSlice";

const url = baseURL;
// const url = 'http://192.168.1.142:3000/api'

export { url };
export * from "./expense";
export * from "./booking";
export * from "./delivery";
export * from "./auth";

export const updateIncentive = () => {
  return async (dispatch: Dispatch) => {
    try {
      let amount = await fetchIncentiveAmount();
      dispatch({
        type: "UPDATE_INCENTIVE",
        payload: Number(amount) >= 0 ? Number(amount).toFixed(0) : "N/A",
      });
    } catch (err : any) { }
  };
};

export const CCAvenueTxnsCount = (data: any) => {
  return async (dispatch: Dispatch) => {
    try {
      let amount = await countsCCAvenueTxns(data);
      dispatch({
        type: "UPDATE_CCAVENUETXNS",
        payload: Number(amount?.notSettledCount) >= 0 ? Number(amount?.notSettledCount).toFixed(0) : "N/A",
      });
    } catch (err : any) { }
  };
};

export const refreshMemos = () => ({ type: "REFRESH_MEMO" });

//area functionality
export const getCity = (pin: any) => {
  return async (dispatch: Dispatch) => {
    // let response = await axios.get(url + '/area/city/' + pin)
    try {
      const city = await getCityByPincode(pin);
      // if (response.data.status != 1) throw "Something went wrong"
      const payload = {
        index : ["city"],
        value : city
      }
      dispatch(changeSimple(payload));
    } catch (err:any) {
      showMessage(err.message || "Invalid Pincode", failed);
    }
  };
};

export const changeBranchHub = (data: any) => ({
  type: "BRANCH_HUB",
  payload: data,
});

//overall entities : material packing
export const getMaterial = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      let reduxData = getState();
      if (reduxData?.booking?.material?.length <= 0) {
        let data = await getMaterialList();
        // if (response.data.status != 1) throw "Could not fetch materials";
        dispatch({
          type: "SET_MATERIAL",
          payload: data,
        });
      }
      else {
        dispatch({
          type: "SET_MATERIAL",
          payload: reduxData?.booking?.material,
        });
      }
    } catch (err : any) { }
  };
};

export const getPackingType = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      let reduxData = getState();
      if (reduxData?.booking?.packingType?.length === undefined) {
        let response = await axios.get(url + "/packing/type/list");
        if (response.data.status != 1) {
          throw "Could not fetch packages";
        }
        dispatch({
          type: "SET_PACKING_TYPE",
          payload: response.data.response,
        });
      }
      else {
        dispatch({
          type: "SET_PACKING_TYPE",
          payload: reduxData?.booking?.packingType,
        });
      }
    } catch (err : any) { }
  };
};

export const checkMemos = (user: any) => async (dispatch: Dispatch) => {
  try {
    const memoResult = await getUnapprovedMemosService({ user });

    await dispatch({
      type: SET_RECEIVED_UNAPPROVED_MEMOS,
      payload: memoResult,
    });
  } catch (err : any) { }
};

// export const setFranchiseRequests = (company) => async (dispatch, getState) => {
//     try{
//         let franchiseRequests = await
//     }catch(err){

//     }
// }

export const approveOrRejectNotifyMemo = (memo: any) => ({
  type: APPROVE_OR_REJECT_NOTIFY_MEMO,
  payload: memo,
});

export const setFranchiseRequestsNotifications = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      const company = getState().user.company.id;
      const data = await pendingApproval(company);
 
      let parentCompanies = data.map((d: any) => d.parent_company);
      let childCompanies = data.map((d: any) => d.child_company);
      let companies = parentCompanies
        .concat(childCompanies)
      let companyMap = new Set(companies);

      let companySet = new Set();


      data.forEach((r: any) => {
        const { parent_company, child_company } = r;
        let intentCompany =
          parent_company != company ? parent_company : child_company;
        if (companyMap.has(intentCompany) && child_company == company) {
          companySet.add(intentCompany);
        }
      });
      const franchiseRequests = Array.from(companySet);
      dispatch({
        type: "INIT:SET_FRANCHISE_REQUESTS",
        payload: franchiseRequests,
      });
    } catch (err : any) {
      showHttpError(err)
    }
  };
};
export const setCities = () => {
  return async (dispatch: Dispatch) => {
    try {
      const res = await axios({
        method: "get",
        url: url + "/city/list",
      });
      dispatch({
        type: "SET_CITIES",
        payload: res.data.response,
      });
    } catch (error) { }
  };
};

export const fetchUserAllBalances = (id: any) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    userAllBalancesService(id)
      .then((res) => {
        let response = {
          ...res,
          fleets: getState().fleet.get('fleets'),
          branches: getState().branch.branchMap,
        };
        dispatch({ type: "USER_ALL_BALANCES", payload: response });
      })
      .catch((error) => {
        showHttpError(error);
      });
  };
};

export const clearSelectedEntity = () => {
  return async (dispatch: any) => {
    try {
      await dispatch({ type: "CLEAR_ENTITY" });
    } catch (err : any) { }
  };
};

export const showAllBalanceModal = () => ({ type: "SHOW_BALANCE_DIALOG" });

export const hideAllBalanceModal = () => ({ type: "HIDE_BALANCE_DIALOG" });

export const assignBranchReq = (data: any) => {
  return async (dispatch: Dispatch) => {
    let response = axios.post(url + "/user/assignbranch", data);
    response
      .then((result:any) => {
        if (result.data.status === 1) {
          dispatch({
            type: "BRANCH_ASSIGN_SUCCESS",
            payload: data,
          });
        } else
          dispatch({
            type: "BRANCH_ASSIGN_FAIL",
          });
      })
      .catch(() => {
        dispatch({
          type: "BRANCH_ASSIGN_FAIL",
        });
      });
  };
};

export const assignDepartReq = (data: any) => {
  return async (dispatch: Dispatch) => {
    let response = axios.post(url + "/user/assigndepart", data);
    response
      .then((result:any) => {
        if (result.data.status === 1) {
          dispatch({
            type: "DEP_ASSIGN_SUCCESS",
            payload: data,
          });
        } else
          dispatch({
            type: "DEP_ASSIGN_FAIL",
          });
      })
      .catch(() => {
        dispatch({
          type: "DEP_ASSIGN_FAIL",
        });
      });
  };
};

export const removeBranch = (name: any) => {
  return {
    type: "REM_BRANCH",
    payload: name,
  };
};

export const addDest = () => {
  return async (dispatch: Dispatch) => {
    try {
      const data = getDest();
      if (data == -1) throw "Create a valid milestone";
      await dispatch({
        type: "ADD_DEST",
        payload: data,
      });
    } catch (err : any) { }
  };
};

export const suggBranch = (data: any, sugg: any) => {
  return {
    type: "SUGG_BR",
    payload: {
      data: data,
      sugg: sugg,
    },
  };
};

// export const fetchBranches = (city: any, sugg: any) => {
//   return async (dispatch: Dispatch) => {
//     try {
//       const response: any = dispatch({
//         type: "FILTER",
//         payload: axios({
//           method: "get",
//           url: url + "/branch/filter/" + city,
//         }),
//       });

//       response.then(async (data: any) => {
//         await dispatch(suggBranch(data.value.data.response, sugg));
//       });
//     } catch (err : any) { }
//   };
// };

// export const changeCityRoute = (city: any, order: any) => {
//   return async (dispatch: Dispatch) => {
//     try {
//       await dispatch({
//         type: "ROUTE_CITY",
//         payload: { order: order, name: city },
//       });
//       const elem: any = document.querySelector(
//         "#city" + order + ' option[value="' + city + '"]'
//       );
//       if (typeof elem === null) {
//       } else {
//         let id = elem.dataset.value;
//         const response: any = dispatch({
//           type: "FILTER",
//           payload: axios({
//             method: "get",
//             url: url + "/branch/filter/" + id,
//           }),
//         });
//         response.then(async (data: any) => {
//           if (data.value.data.status)
//             await dispatch({
//               type: "ROUTE_SUGG",
//               payload: { data: data.value.data.response, order: order },
//             });
//         });
//       }
//     } catch (err : any) { }
//   };
// };

export const changeBranchRoute = (branch: any, order: any) => {
  return async (dispatch: Dispatch) => {
    await dispatch({
      type: "ROUTE_BRANCH",
      payload: { order: order, name: branch },
    });
  };
};

// export const fetchAllBranches = (sugg: any) => {
//   return (dispatch: Dispatch) => {
//     try {
//       const response: any = dispatch({
//         type: "ALL_BRANCHES",
//         payload: axios({
//           method: "get",
//           url: url + "/branch/all/",
//         }),
//       });

//       response.then((data: any) => {
//         dispatch(brSearch(data.value.data.response, sugg));
//       });
//     } catch (err : any) { }
//   };
// };

export const allfleets = (data: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const response: any = dispatch({
        type: "ALL_BRANCHES",
        payload: axios({
          method: "post",
          url: url + "/fleet/all/",
          data: data,
        }),
      });

      response.then(async (data: any) => {
        await dispatch({
          type: "ALL_FLEETS",
          payload: data.value.data.response,
        });
      });
    } catch (err : any) { }
  };
};

export const fetchCity = (like: any, sugg: any) => {
  return (dispatch: Dispatch) => {
    const response: any = dispatch({
      type: "FILTER",
      payload: axios({
        method: "post",
        url: url + "/city/filter/" + like,
      }),
    });

    response.then((data: any) => {
      dispatch(suggCity(data.value.data.response, sugg));
    });
  };
};

export const suggCity = (data: any, sugg: any) => {
  return {
    type: "SUGG_CITY",
    payload: { data: data, sugg: sugg },
  };
};

export const brSearch = (data: any, sugg: any) => {
  return {
    type: "BR_SEARCH",
    payload: {
      sugg: sugg,
      data: data,
    },
  };
};

//rate creation module
export const getAllRoutes = (data: any) => {
  return async (dispatch: Dispatch) => {
    let { uid, cid, token } = data;
    let response = await axios.post(url + "/route/company", {
      user: uid,
      companyId: cid,
      token,
    });
    if (response.data.status != 1) throw "Could not fetch routes";
    await dispatch({
      type: "SET_ALL_ROUTES",
      payload: response.data.response,
    });
  };
};

export const filterRoute = (like: any, sugg: any) => {
  return (dispatch: Dispatch) => {
    const response: any = dispatch({
      type: "FILTER_ROUTE",
      payload: axios({
        method: "post",
        url: url + "/route/filter/" + like,
      }),
    });

    response.then((data: any) => {
      dispatch({
        type: "SUGG_ROUTE",
        payload: { response: data.value.data.response, sugg: sugg },
      });
    });
  };
};

export const getRoutes = () => {
  return async (dispatch: any) => {
    try {
      let response = await fetchRouteForExpense();
      dispatch({ type: GET_ROUTES, payload: response });
    } catch (error) { }
  };
};

export const getRoute = (id: any) => {
  return {
    type: "GET_ROUTE",
    payload: axios({
      method: "get",
      url: url + "/route/view/" + id,
    }),
  };
};

export const fetchRate = (id: any) => {
  return {
    type: "SELECT_RATE",
    payload: id,
  };
};

export const addRate = (id: any) => {
  const elem1: any = document.getElementById("from");
  const elem2: any = document.getElementById("to");
  const elem3: any = document.getElementById("price");
  let rate: any;
  if (typeof elem1 !== null && typeof elem2 !== null && typeof elem3 !== null) {
    rate = {
      min: elem1.value,
      max: elem2.value,
      price: elem3.value,
    };
  }
  return {
    type: "ADD_RATE",
    payload: { id: id, rate: rate },
  };
};

export const addRateByType = (id: any) => {
  const elem1: any = document.getElementById("ptype");
  const elem2: any = document.getElementById("pprice");
  let rate: any;
  if (typeof elem1 !== null && typeof elem2 !== null) {
    rate = {
      type: elem1.value,
      price: elem2.value,
    };
  }
  return {
    type: "ADD_RATE_TYPE",
    payload: { id: id, rate: rate },
  };
};

export const updateFrom = (id: any, i: any, value: any) => {
  return {
    type: "FROM",
    payload: {
      id: id,
      i: i,
      value: value,
    },
  };
};

export const updateTo = (id: any, i: any, value: any) => {
  return {
    type: "TO",
    payload: {
      id: id,
      i: i,
      value: value,
    },
  };
};

export const updatePrice = (id: any, i: any, value: any) => {
  return {
    type: "PRICE",
    payload: {
      id: id,
      i: i,
      value: value,
    },
  };
};

export const updatePriceByType = (id: any, i: any, value: any) => {
  return {
    type: "PRICE_TYPE",
    payload: {
      id: id,
      i: i,
      value: value,
    },
  };
};

export const updateType = (id: any, i: any, value: any) => {
  return {
    type: "TYPE",
    payload: {
      id: id,
      i: i,
      value: value,
    },
  };
};

export const createRate = (data: any) => {
  return (dispatch: Dispatch) => {
    const response: any = dispatch({
      type: "CREATE_RATE",
      payload: axios({
        method: "post",
        url: url + "/rate/create/",
        data: data,
      }),
    });

    response.then(() => { });
  };
};

//fuel module
export const openKM = (value: any) => {
  return {
    type: "OPEN_KM",
    payload: value,
  };
};

export const closeKM = (value: any) => {
  return {
    type: "CLOSE_KM",
    payload: value,
  };
};

export const setPPL = (value: any) => {
  return {
    type: "PPL",
    payload: value,
  };
};

// export const updateLoc = (bid, i, branchName, isNew) => {
//   return (dispatch) => {
//     const response = dispatch({
//       type: "GET_BRANCH_DUMMY",
//       payload: axios({
//         method: "get",
//         url: url + "/branch/view/" + bid,
//       }),
//     });
//     if (!isNew) {
//       response.then((data) => {
//         let { latitude, longitude } = data.value.data.response.location;
//         dispatch({
//           type: "LOC_UPDATE",
//           payload: {
//             lat: latitude,
//             lng: longitude,
//             order: i,
//             branchName: branchName,
//           },
//         });
//       });
//     }
//   };
// };
// export const updateEditLoc = (bid, i, branchName, isNew) => {
//   return (dispatch) => {
//     const response = dispatch({
//       type: "GET_BRANCH_DUMMY",
//       payload: axios({
//         method: "get",
//         url: url + "/branch/view/" + bid,
//       }),
//     });
//     if (!isNew) {
//       response.then((data) => {
//         let { latitude, longitude } = data.value.data.response.location;
//         dispatch({
//           type: "LOC_EDIT_UPDATE",
//           payload: {
//             lat: latitude,
//             lng: longitude,
//             order: i,
//             branchName: branchName,
//           },
//         });
//       });
//     }
//   };
// };
// export const updateNewLoc = (bid, i, branchName) => {
//   return (dispatch) => {
//     const response = dispatch({
//       type: "GET_BRANCH_DUMMY",
//       payload: axios({
//         method: "get",
//         url: url + "/branch/view/" + bid,
//       }),
//     });

//     response.then((data) => {
//       let { latitude, longitude } = data.value.data.response.location;
//       dispatch({
//         type: "NEW_LOC_UPDATE",
//         payload: {
//           lat: latitude,
//           lng: longitude,
//           order: i,
//           branchName: branchName,
//           bid: bid,
//         },
//       });
//     });
//   };
// };
// export const updateNewEditLoc = (bid, i, branchName) => {
//   return (dispatch) => {
//     const response = dispatch({
//       type: "GET_BRANCH_DUMMY",
//       payload: axios({
//         method: "get",
//         url: url + "/branch/view/" + bid,
//       }),
//     });

//     response.then((data) => {
//       let { latitude, longitude } = data.value.data.response.location;
//       dispatch({
//         type: "NEW_EDIT_LOC_UPDATE",
//         payload: {
//           lat: latitude,
//           lng: longitude,
//           order: i,
//           branchName: branchName,
//           bid: bid,
//         },
//       });
//     });
//   };
// };
export const selectRoute = (order: any) => {
  return {
    type: "SELECT_FUEL_ROUTE",
    payload: { order: order },
  };
};
export const addPlace = (data: any) => {
  return {
    type: "ADD_PLACE",
    payload: data,
  };
};
export const updateMap = (i: any) => {
  return {
    type: "UPDATE_MAP",
    payload: { i: i },
  };
};
export const filterFuel = (data: any) => {
  return async (dispatch: Dispatch) => {
    if (data.uid) {
      let fuels = await axios({
        method: "post",
        url: url + "/fuel/filter/" + data.uid,
        data: data,
      });
      await dispatch({
        type: "SET_FUELS_EDIT",
        payload: fuels.data.response,
      });
    } else {
      let fuels = await axios({
        method: "post",
        url: url + "/fuel/filter/-1",
        data: data,
      });
      await dispatch({
        type: "SET_FUELS_EDIT",
        payload: fuels.data.response,
      });
    }
  };
};
export const changeVnum = (data: any) => {
  return {
    type: "FUEL_VNUM",
    payload: data,
  };
};
export const changeFuelContact = (data: any) => {
  return {
    type: "FUEL_CONTACT",
    payload: data,
  };
};
export const editFuelVnum = (data: any) => {
  return {
    type: "EDIT_FUEL_VNUM",
    payload: data,
  };
};
export const editFuelContact = (data: any) => {
  return {
    type: "EDIT_FUEL_CONTACT",
    payload: data,
  };
};
export const editFuelOpen = (data: any) => {
  return {
    type: "EDIT_FUEL_OPEN",
    payload: data,
  };
};
export const editFuelClose = (data: any) => {
  return {
    type: "EDIT_FUEL_CLOSE",
    payload: data,
  };
};
export const editFuelAmt = (data: any) => {
  return {
    type: "EDIT_FUEL_AMT",
    payload: data,
  };
};
export const editFuelPPL = (data: any) => {
  return {
    type: "EDIT_FUEL_PPL",
    payload: data,
  };
};

export const addEditPlace = (data: any) => {
  return {
    type: "ADD_EDIT_PLACE",
    payload: data,
  };
};
export const deleteEditPlace = (i: any) => {
  return {
    type: "DEL_EDIT_PLACE",
    payload: parseInt(i, 10),
  };
};
export const changeFuelFilterVnum = (data: any) => {
  return {
    type: "FUEL_FILTER_VNUM",
    payload: data,
  };
};
export const changeFuelFilterContact = (data: any) => {
  return {
    type: "FUEL_FILTER_CONTACT",
    payload: data,
  };
};
export const changeFuelFromDate = (data: any) => {
  return {
    type: "FUEL_FROM",
    payload: data,
  };
};
export const changeFuelToDate = (data: any) => {
  return {
    type: "FUEL_TO",
    payload: data,
  };
};
export const selectFuel = (_id: any) => {
  return {
    type: "SELECT_FUEL",
    payload: { id: _id },
  };
};
export const setSelectedPPL = (value: any) => {
  return {
    type: "SET_SELECTED_PPL",
    payload: value,
  };
};
export const fuelReport = (data: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: "FUEL_REP",
      payload: axios({
        url: url + "/fuel/report/" + data.uid,
        method: "POST",
        responseType: "blob", // important
        data: data,
      }),
    });
  };
};
export const generateReport = (data: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: "FUEL_REP",
      payload: axios({
        url: url + "/fuel/genericReport",
        method: "POST",
        responseType: "blob", // important
        data: data,
      }),
    });
  };
};

//Edit Branch Select
export const selectEditBranch = (bid: any) => {
  return async (dispatch: Dispatch) => {
    try {
      let response = await axios(url + "/branch/view/" + bid);
      if (response.data.status === 1) {
        await dispatch({
          type: "BRANCH_EDIT_FETCH",
          payload: response.data.response,
        });
        await dispatch({
          type: "TRANS",
          payload: response.data.response.transhipment,
        });
        await dispatch({
          type: "FRANC",
          payload: response.data.response.franchise,
        });
      } else throw "Something went wrong";
    } catch (err : any) { }
  };
};

export const updateTransMin = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_TR_MIN",
    payload: { value: value, i: i, t: t },
  };
};
export const updateTransMax = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_TR_MAX",
    payload: { value: value, i: i, t: t },
  };
};
export const updateTransPrice = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_TR_PRICE",
    payload: { value: value, i: i, t: t },
  };
};
export const addTrans = (slab: any, t: any) => {
  return {
    type: "ADD_TRANS",
    payload: { slab: slab, t: t },
  };
};
export const updateFrBookMin = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_FR_BOOK_MIN",
    payload: { value: value, i: i, t: t },
  };
};
export const updateFrBookMax = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_FR_BOOK_MAX",
    payload: { value: value, i: i, t: t },
  };
};
export const updateFrBookPrice = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_FR_BOOK_PRICE",
    payload: { value: value, i: i, t: t },
  };
};
export const addBook = (slab: any, t: any) => {
  return {
    type: "ADD_BOOK",
    payload: { slab: slab, t: t },
  };
};
export const updateFrDelMin = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_FR_DEL_MIN",
    payload: { value: value, i: i, t: t },
  };
};
export const updateFrDelMax = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_FR_DEL_MAX",
    payload: { value: value, i: i, t: t },
  };
};
export const updateFrDelPrice = (value: any, i: any, t: any) => {
  return {
    type: "UPDATE_FR_DEL_PRICE",
    payload: { value: value, i: i, t: t },
  };
};
export const addDel = (slab: any, t: any): any => {
  return {
    type: "ADD_DEL",
    payload: { slab: slab, t: t },
  };
};
export const changePPF = () => {
  return {
    type: "PPF",
  };
};
export const changeKGW = () => {
  return {
    type: "KGW",
  };
};
export const changeFRPPF = () => {
  return {
    type: "FR_PPF",
  };
};
export const changeFRKGW = () => {
  return {
    type: "FR_KGW",
  };
};

// not used and module not used where this is imported.
export const getUserByContact = (data: any) => {
  let { contact } = data;
  return async (dispatch: Dispatch) => {
    let response = axios.post(url + "/user/viewbycontact/" + contact, data);
    response
      .then((data: any) => {
        if (data.data.status === 1) {
          dispatch({
            type: "GET_USER_BY_CONTACT",
            payload: data.data.response,
          });
        } else {
          dispatch({
            type: "GET_NAME_BY_CONTACT_FAIL",
          });
          throw "status fail";
        }
      })
      .catch(() => { });
  };
};

//booking edit sub module

export const resetEdit = (data?: any) => ({ type: RESET_EDIT, payload: data });

//loading module

//unloading module

export const fetchingUnload = () => ({ type: "UNLOAD_PENDING" });

export const unloadReq = (data: any) => {
  return async (dispatch: any) => {
    try {
      let { user, ...rest } = data;
      window.scrollTo(0, 0);
      let response = await unloadPackages(rest);
      await dispatch({
        type: "UNLOAD_SUCCESS",
        payload: response,
      });
    } catch (err : any) {
      showHttpError(err);

      dispatch({ type: HIDE_LOADER });
      // await dispatch({
      //     type: UNLOAD_FAIL,
      //     payload: {
      //         reasons: [{ message: 'Could not unload packages' }]
      //     }
      // })
    }
  };
};

export const generateFedexPickup = (data: any) => async (dispatch: any) => {
  try {
    let { packages } = data;
    window.scrollTo(0, 0);
    let { fedexPickupNumber } = await fedexCreatePickup({ packages });
    await unloadPackages();

    await dispatch({
      type: "FEDEX_PICKUP_SUCCESS",
      payload: { fedexPickupNumber, packages },
    });
    // await dispatch(updateAllDockets())
    // await dispatch(closeLoadModal())
  } catch (err:any) {
    showMessage(
      err && err.message ? err.message : " Pickup Request failed.",
      "salmon"
    );
    // dispatch({
    //     type: FEDEX_PICKUP_FAIL,
    //     payload:
    // })
    // dispatch(closeLoadModal())
  }
};

export const getMyOdaPackages = (payload: any, noloader?: any) => {
  return async (dispatch: any) => {
    try {
      if (!noloader) await dispatch({ type: SHOW_LOADER });
      // await dispatch(fetchingUnload());
      const response = await getOutForDeliveryData(payload);

      await dispatch({
        type: "OUT_FOR_DELIVERY_PACKAGES_REGNUMWISE",
        payload: { packages: response },
      });
      dispatch({ type: HIDE_LOADER });
    } catch (err : any) {
      dispatch({ type: HIDE_LOADER });
    }
  };
};
export const clearReNumwiseDocket = () => ({
  type: "CLEAR_REGNUM_WISE_DOCKET",
});

export const deliveryStart = () => ({ type: DELIVERY_PENDING });

export const deliveryEnd = () => ({ type: DELIVERY_SUCCESS });

export const delAmt = (val: any) => ({ type: "DEL_AMT", payload: val });

export const getBookingDelivery = (data: any) => {
  return async (dispatch: any, getState: any) => {
    try {
      const sub = getState().user.loginType;
      const entity =
        getState().user.loginType === "B"
          ? getState().user.opBranch._id
          : getState().user.opFleet._id;
      const payload = {
        docket: data.docketNo,
        sub: sub,
        entity: entity,
        queryType: "delivery",
        old: false,
      };
      let response = await fetchDocketDetails(payload);

      if (response.data.status !== 1) throw "No such docket number found";
      await dispatch({
        type: "DELIVERY_SET",
        payload: response.data.response,
      });
    } catch (err : any) { }
  };
};

export const changeDelFr = (val: any) => ({ type: "DEL_FR", payload: val });

export const changeDelMode = (val: any) => ({ type: "DEL_MODE", payload: val });

export const changeDelRate = (val: any) => ({ type: "DEL_RATE", payload: val });

export const setDocket = (payload?: any, func?: any, args?: any) => {
  let deliveryFlag = /delivery/.test(args);
  return async (dispatch: any, getState: () => RootState) => {
    try {
      let { packages, isDirectUrl } = payload;

      if (packages.length < 1) {
        // showErrorMessage("this docket has no packages.");
        showMessage("this docket has no packages.", failed);
        return;
      }
      if ((!getState().user as any)?.allCities) {
        await dispatch(setCities());
      }
      let { originBranch, destCity } = packages[0];
      if (
        typeof originBranch == "object" &&
        originBranch.hasOwnProperty("_id")
      ) {
        originBranch = originBranch._id;
      }
      if (typeof destCity == "object" && destCity.hasOwnProperty("_id")) {
        destCity = destCity._id;
      }
      let across = await getAcrossService(
        originBranch,
        payload.docket.isFedexBooking
          ? payload.docket.destBranch.address.pincode
          : destCity,
        isDirectUrl
      );

      await dispatch({ type: SET_ACROSS, payload: across });
      const { allcities } = getState().user;
      dispatch({
        type: SET_DOCKET,
        payload: {
          ...payload,
          // routes,
          delivery: deliveryFlag,
          allcities,
        },
      });
      if (typeof func === "function") {
        func(args);
      }
    } catch (err : any) {
      return err
    }
  };
};

export const setTrackingnumber = (data: any) => ({
  type: "SET_TRACKING_NUMBER",
  payload: data,
});

export const showLoader = () => ({ type: SHOW_LOADER });

export const hideLoader = () => ({ type: HIDE_LOADER });

export const outForDeliveryRemark = (data: any, cb: any, setRemarks: any) => {
  return async (dispatch: any, getState: any) => {
    try {
      let { user, ...rest } = data;
      // throw 'Yuhi'
      await axios.post(url + "/package/remark", jsonToFormdata(rest));
      const company = getState().user.company._id,
        branch = getState().user.opBranch._id;

      let packagePayload = {
        token: getState().user.token,
        uid: getState().user.uid,
        sub: getState().user.loginType,
        entity:
          getState().user.loginType == "B"
            ? getState().user.opBranch._id
            : getState().user.opFleet._id,
        company,
        branch,
      };
      await dispatch(getMyOdaPackages(packagePayload, true));
      await setRemarks();
      cb();
    } catch (error) { }
  };
};

export const returnODAPackages = (data: any) => {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(showLoader());
      await returnODAPackagesService(data);

      let packagePayload = {
        sub: getState().user.loginType,
        entity:
          getState().user.loginType == "B"
            ? getState().user.opBranch._id
            : getState().user.opFleet._id,
      };
      await dispatch(getMyOdaPackages(packagePayload, true));
      dispatch(hideLoader());
    } catch (error) {
      showMessage("Something went wrong!", "salmon");
      dispatch(hideLoader());
    }
  };
};

export const updateBookingCounters = () => {
  return async (dispatch: any, getState: any) => {
    try {
      const user = getState().user;
      if (user.loginType) {
        const sub = user.loginType;
        const entity =
          user.loginType === "B" ? user.opBranch._id : user.opFleet._id;
        const result = await fetchBranchwiseBookingCounters({ sub, entity });
        dispatch({
          type: "CHANGE_BOOKING_COUNTERS",
          payload: result,
        });
      }
    } catch (err : any) { }
  };
};

export const verifyRemarks = (data: any) => ({
  type: "SET_VERIFY_REMARKS",
  payload: data,
});
